/** Human-readable labels for analysis.json field paths (mirrors backend analysis_fields.py). */

export const FIELD_LABELS = {
  "general.customer_name": "Customer name",
  "general.technologies_involved": "Technologies involved",
  "general.project_scope": "Project scope",
  "general.important_aspects": "Important aspects",
  "general.missing_key_information": "Missing key information",
  "general.executive_summary": "Executive summary",
  "design.ddos.project_type_cloud_onprem_hybrid": "DDoS project type",
  "design.ddos.cloud.diversion_type": "Cloud DDoS diversion type",
  "design.ddos.cloud.mitigation_capacity": "Cloud mitigation capacity",
  "design.ddos.cloud.legitimate_traffic_throughput": "Cloud legitimate throughput",
  "design.ddos.cloud.customer_has_own_as": "Customer own AS",
  "design.ddos.cloud.number_of_networks_to_protect": "Networks to protect",
  "design.ddos.cloud.dns_diversion_assets": "DNS diversion assets",
  "design.ddos.cloud.dns_ddos_protection_required": "DNS DDoS protection",
  "design.ddos.cloud.https_flood_protection_required": "HTTPS flood protection",
  "design.ddos.cloud.management_visibility_features": "Cloud DDoS management",
  "design.ddos.cloud.reporting_needs": "Cloud DDoS reporting",
  "design.ddos.cloud.logs_needs": "Cloud DDoS logs",
  "design.ddos.cloud.storage_retention_needs": "Cloud DDoS retention",
  "design.ddos.onprem.number_of_equipment": "Number of DDoS equipment",
  "design.ddos.onprem.ha_requirements": "DDoS HA requirements",
  "design.ddos.onprem.deployment_mode": "DDoS deployment mode",
  "design.ddos.onprem.mitigation_throughput": "DDoS mitigation throughput",
  "design.ddos.onprem.legitimate_traffic_throughput": "DDoS legitimate throughput",
  "design.ddos.onprem.interfaces_and_type": "DDoS interfaces",
  "design.ddos.onprem.power_supply": "DDoS power supply",
  "design.ddos.onprem.bypass_requirements": "Bypass requirement",
  "design.ddos.onprem.cps_pps_concurrent_connections": "DDoS CPS/PPS",
  "design.ddos.onprem.dns_ddos_protection_required": "On-prem DNS DDoS",
  "design.ddos.onprem.https_flood_protection_required": "On-prem HTTPS flood",
  "design.ddos.onprem.management_visibility_features": "On-prem DDoS management",
  "design.ddos.onprem.reporting_needs": "On-prem DDoS reporting",
  "design.ddos.onprem.logs_needs": "On-prem DDoS logs",
  "design.ddos.onprem.storage_retention_needs": "On-prem DDoS retention",
  "design.alteon.number_of_equipment": "Number of Alteon equipment",
  "design.alteon.ha_requirements": "Alteon HA",
  "design.alteon.throughput_l4": "Alteon L4 throughput",
  "design.alteon.throughput_l7": "Alteon L7 throughput",
  "design.alteon.interfaces_and_type": "Alteon interfaces",
  "design.alteon.ram_disk": "Alteon RAM/disk",
  "design.alteon.power_supply": "Alteon power supply",
  "design.alteon.cps_pps_concurrent_connections": "Alteon CPS/PPS",
  "design.alteon.ssl_capacity": "Alteon SSL capacity",
  "design.alteon.compression_throughput": "Compression throughput",
  "design.alteon.virtual_instances_partitions_route_domains": "Number of virtual instances",
  "design.alteon.security_features": "Alteon security features",
  "design.alteon.management_visibility_features": "Alteon management",
  "design.alteon.reporting_needs": "Alteon reporting",
  "design.alteon.logs_needs": "Alteon logs",
  "design.alteon.storage_retention_needs": "Alteon retention",
  "design.application_security.deployment_model_cloud_onprem_both": "AppSec deployment model",
  "design.application_security.onprem_deployment_mode": "AppSec on-prem mode",
  "design.application_security.ha_requirements": "AppSec HA",
  "design.application_security.throughput_l4": "AppSec L4 throughput",
  "design.application_security.throughput_l7": "AppSec L7 throughput",
  "design.application_security.interfaces_and_type": "AppSec interfaces",
  "design.application_security.ram_disk": "AppSec RAM/disk",
  "design.application_security.power_supply": "AppSec power supply",
  "design.application_security.cps_pps_concurrent_connections": "AppSec CPS/PPS",
  "design.application_security.ssl_capacity": "AppSec SSL capacity",
  "design.application_security.number_of_applications": "Number of applications",
  "design.application_security.number_of_apis": "Number of APIs",
  "design.application_security.api_discovery_required": "API discovery",
  "design.application_security.api_special_features": "API special features",
  "design.application_security.bot_manager_required": "Bot Manager",
  "design.application_security.sophisticated_bot_requirement_1": "Advanced bot req 1",
  "design.application_security.sophisticated_bot_requirement_2": "Advanced bot req 2",
  "design.application_security.client_side_protection_required": "Client-side protection",
  "design.application_security.pci_certification_capabilities_required": "PCI capabilities",
  "design.application_security.llm_firewall_required": "LLM firewall",
  "design.application_security.ddos_requested_and_capacity": "AppSec DDoS capacity",
  "design.application_security.l7_ddos_requested": "L7 DDoS",
  "design.application_security.management_visibility_features": "AppSec management",
  "design.application_security.logs_needs": "AppSec logs",
  "design.application_security.storage_retention_needs": "AppSec retention",
  "design.application_security.reporting_needs": "AppSec reporting",
  "design.application_security.ai_special_capabilities": "AI capabilities",
  "design.application_security.cdn_requirements": "CDN requirements",
  "design.application_security.dns_hosted_zones": "DNS hosted zones",
  "design.application_security.dns_queries_per_month": "Monthly DNS queries",
  "design.application_security.api_calls_or_requests_per_month": "Monthly API requests",
  "design.application_security.monthly_traffic_volume_tb_gb": "Monthly traffic volume",
  "design.application_security.total_http_https_requests_per_month": "Monthly HTTP/HTTPS requests",
  "design.global_management.centralized_management_required": "Centralized management required",
  "design.global_management.management_platform": "Management platform",
  "design.global_management.managed_technologies": "Managed technologies",
  "design.global_management.deployment_model": "Deployment model",
  "design.global_management.ha_requirements": "Management HA",
  "design.global_management.visibility_features": "Visibility features",
  "design.global_management.reporting_needs": "Reporting needs",
  "design.global_management.logs_needs": "Logs needs",
  "design.global_management.storage_retention_needs": "Storage/retention needs",
  "design.global_management.event_correlation": "Event correlation",
  "design.global_management.forensic_analysis": "Forensic analysis",
  "design.global_management.rbac_or_user_roles": "RBAC/user roles",
  "design.global_management.audit_trail": "Audit trail",
  "design.global_management.integrations": "Integrations",
  "design.global_management.admin_access_and_resilience": "Admin access and resilience",
  "design.global_management.licensing_or_scope_limits": "Licensing or scope limits",
  "design.global_management.detection.flows_per_second": "Flows per second",
  "design.global_management.detection.routers_to_monitor": "Routers to monitor",
  "design.global_management.detection.flow_protocols": "Flow protocols",
  "design.global_management.detection.prefixes_and_objects": "Prefixes and objects",
  "design.global_management.detection.traffic_visibility_and_analytics": "Traffic visibility and analytics",
  "design.global_management.detection.diversion_methods": "Diversion methods",
  "sti.support.number_of_years": "Support Period",
  "sti.support.rma_replacement_time": "RMA replacement time",
  "sti.support.under_attack_support_sla": "Under-attack SLA",
  "sti.support.solution_availability": "Solution availability",
  "sti.support.support_availability": "Support availability",
  "sti.support.special_customer_service_tam_csm_vendor_engineer": "Special customer service",
  "sti.training.certified_or_knowledge_transfer": "Training type",
  "sti.training.onsite_or_online": "Training modality",
  "sti.training.customer_facilities": "Training location",
  "sti.training.number_of_people": "Training participants",
  "sti.training.number_of_sessions": "Training sessions",
  "sti.implementation.vendor_implementation_required": "Vendor implementation",
  "sti.implementation.documentation_needs": "Implementation documentation",
  "sti.implementation.attack_tests_required": "Attack tests",
  "sti.implementation.attack_test_requirements": "Attack test requirements",
  "sti.implementation.vendor_engineer_certification_required": "Vendor engineer certification",
  "sti.implementation.partner_engineer_certification_required": "Partner engineer certification",
  "sti.implementation.delivery_timeline": "Delivery timeline",
  "commercial_admin.equipment_delivery_times": "Equipment delivery times",
  "commercial_admin.payment_terms": "Payment terms",
  "commercial_admin.special_contractual_requirements": "Contractual requirements",
  "commercial_admin.acquisition_process_dates": "Acquisition dates",
  "commercial_admin.penalties": "Penalties",
  "commercial_admin.offer_validity": "Offer validity",
  "commercial_admin.quote_submission_requirements": "Quote submission",
};

export const FIELD_LABELS_ES = {
  "design.application_security.ha_requirements": "Requisitos de HA",
  "design.application_security.power_supply": "Fuente de poder WAF",
  "design.ddos.onprem.power_supply": "Fuente de poder DDoS",
  "design.alteon.power_supply": "Fuente de poder Alteon",
  "design.application_security.throughput_l7": "Throughput L7",
  "design.application_security.throughput_l4": "Throughput L4",
  "design.application_security.management_visibility_features": "Gestión y visibilidad",
  "design.application_security.reporting_needs": "Requerimientos de reportes",
  "design.application_security.logs_needs": "Requerimientos de logs",
  "design.application_security.storage_retention_needs": "Retención / almacenamiento",
  "design.application_security.cdn_requirements": "Requerimientos de CDN",
  "design.application_security.dns_hosted_zones": "Zonas DNS hospedadas",
  "design.application_security.dns_queries_per_month": "Consultas DNS mensuales",
  "design.ddos.onprem.ha_requirements": "Requisitos de HA",
  "design.ddos.onprem.management_visibility_features": "Gestión y visibilidad",
  "design.ddos.onprem.reporting_needs": "Requerimientos de reportes",
  "design.ddos.onprem.logs_needs": "Requerimientos de logs",
  "design.ddos.onprem.storage_retention_needs": "Retención / almacenamiento",
  "design.alteon.ha_requirements": "Requisitos de HA",
  "design.alteon.compression_throughput": "Throughput de Compresión",
  "design.alteon.virtual_instances_partitions_route_domains": "Número de instancias virtuales",
  "design.alteon.security_features": "Características de seguridad",
  "design.alteon.management_visibility_features": "Gestión y visibilidad",
  "design.alteon.reporting_needs": "Requerimientos de reportes",
  "design.alteon.logs_needs": "Requerimientos de logs",
  "design.alteon.storage_retention_needs": "Retención / almacenamiento",
  "design.global_management.visibility_features": "Gestión y visibilidad",
  "design.global_management.reporting_needs": "Requerimientos de reportes",
  "design.global_management.logs_needs": "Requerimientos de logs",
  "design.global_management.storage_retention_needs": "Retención / almacenamiento",
  "design.global_management.detection.flows_per_second": "Flujos por segundo",
  "design.global_management.detection.routers_to_monitor": "Routers a monitorear",
  "design.global_management.detection.flow_protocols": "Protocolos de flujo",
  "design.global_management.detection.prefixes_and_objects": "Prefijos y objetos",
  "design.global_management.detection.traffic_visibility_and_analytics": "Visibilidad y analítica de tráfico",
  "design.global_management.detection.diversion_methods": "Métodos de desvío",
  "general.executive_summary": "Resumen ejecutivo",
  "general.technologies_involved": "Tecnologías involucradas",
  "general.project_scope": "Alcance del proyecto",
};

export const DESIGN_SECTIONS = [
  { id: "ddos.project_type", label: "DDoS Design", path: ["design", "ddos", "project_type_cloud_onprem_hybrid"] },
  { id: "ddos.cloud", label: "Cloud DDoS", path: ["design", "ddos", "cloud"] },
  { id: "ddos.onprem", label: "On-premise DDoS", path: ["design", "ddos", "onprem"] },
  { id: "global_management", label: "Management Design", path: ["design", "global_management"] },
  { id: "alteon", label: "ADC Design", path: ["design", "alteon"] },
  { id: "application_security", label: "AppSec Design", path: ["design", "application_security"] },
];

export const STI_SECTIONS = [
  { id: "support", label: "Support", path: ["support_training_implementation", "support"] },
  { id: "training", label: "Training", path: ["support_training_implementation", "training"] },
  { id: "implementation", label: "Implementation", path: ["support_training_implementation", "implementation"] },
];

export const COMMERCIAL_SECTIONS = [
  { id: "commercial", label: "Commercial / Administrative", path: ["commercial_administrative"] },
];

export function fieldLabel(fieldId, language = "en") {
  if (language === "es") {
    return FIELD_LABELS_ES[fieldId] || FIELD_LABELS[fieldId] || humanizeFieldId(fieldId);
  }
  return FIELD_LABELS[fieldId] || humanizeFieldId(fieldId);
}

function humanizeFieldId(fieldId) {
  const last = (fieldId || "").split(".").pop() || fieldId;
  return last.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
